module.exports = __webpack_public_path__ + "img/rule-SCHR.35385906.svg";